import { useMemo, useState } from 'react';
import styles from '../FormAfterSignUp.module.css';
import { useAppSelector } from '../../../app/hooks';
import CategoryCard from './CategoryCard';
import { TCategory } from '../../../types';
import WelcomeModal from './WelcomeModal';
// Images
import { registeredLogo, unregisteredImg } from '../../../assets/images/formAfterSignUp/index';
import { useMutation } from 'react-query';
import axios, { AxiosError } from 'axios';
import { baseUrl_, timeout } from '../../../utils/constants';
import { toast } from 'react-toastify';
import UnVerifiedPhoneModal from '../../../components/global/UnVerifiedPhoneModal';
import OtpModal from '../../../components/global/OtpModal';
import { useNavigate } from 'react-router-dom';
import { handleError } from '../../../utils/errorHandler';
import { decryptJson } from '../../../utils/decryptJson';
import { encryptData } from '../../../utils/encryptJson';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import jwtDecode from 'jwt-decode';
import ReactGA from 'react-ga4';
import customToast, { ToastType } from '../../../components_/Toast';
import { Request } from '../../../apis/request';

type TImage = {
  src: string;
};
type TUpdateUser = {
  ageOfBusiness: string;
  businessRegistered: boolean;
};
const BusinessImg = ({ src }: TImage) => {
  return <img src={src} className='mb-4' alt='registration.png' style={{ height: '70px' }} />;
};

export function ChooseCategory() {
  const [selectedOption, setSelectedOption] = useState<TCategory>('');
  const [showModal, setShowModal] = useState(false);
  const [username, setUsername] = useState('');
  const [showUnverifiedPhoneModal, setShowUnverifiedPhoneModal] = useState(false);
  const [tokenSent, setTokenSent] = useState(false);
  const yearsInBusiness = useAppSelector((state) => state.formAfterSignUp.yearsInBusiness);

  const token = localStorage.getItem('signup-token');
  const loginToken = localStorage.getItem('login-token');
  const phoneOtpToken = localStorage.getItem('token-for-phone-otp');

  const isDisabled = useMemo(() => (selectedOption !== '' ? false : true), [selectedOption]);

  const removeSignUpTokenAfterSuccessfulSignup = () => {
    //   REMOVE SIGNUP TOKEN IF ANY EXISTS
    localStorage.removeItem('signup-token');
    localStorage.removeItem('signup-email');
  };
  const colorStyle = !isDisabled
    ? styles.proceedBtnbgColorActive
    : styles.proceedBtnbgColorDisabled;

  const showErrorToastMessage = (message: string) => {
    customToast(message, ToastType.success);
  };

  const errorFn = (error: AxiosError<{ message: string }>) => {
    if (error?.response?.data?.message) {
      showErrorToastMessage(error.response.data.message);
    } else {
      showErrorToastMessage('Something went wrong');
    }
  };

  const decode: any = jwtDecode(token! ?? loginToken! ?? phoneOtpToken!);
  const { email, firstName, lastName, phoneNumber } = decode;

  const { id, isPhoneNumberVerified } = useAppSelector((state) => state.auth.loggedInUserDetails);
  const tokenToUse = loginToken ? loginToken : token;
  const updateUserInfo = useMutation(
    (data: TUpdateUser) =>
      Request.patch(`/user`, encryptData(data), {
        headers: {
          Authorization: `Bearer ${tokenToUse ?? ''}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      }),
    {
      onSuccess: (data) => {
        const res = decryptJson(data?.data?.data);
        if (id && !isPhoneNumberVerified) {
          setShowUnverifiedPhoneModal(true);
        } else if (id && isPhoneNumberVerified) {
          navigate('/dashboard');
          //   registerNetcoreActivity(
          //     {
          //       emailAddress: email && email,
          //       firstName: firstName && firstName,
          //       lastName: lastName && lastName,
          //       mobileNumber: phoneNumber && phoneNumber,
          //     },
          //     'TBH_SIGN_UP_CHOOSE_CATEGORY',
          //   );

          //   ReactGA.event({
          //     category: 'formSubmit',
          //       action: 'TBH_SIGN_UP_CHOOSE_CATEGORY',
          //     label: 'TBH_SIGN_UP_CHOOSE_CATEGORY',
          //   });
        } else if (!id) {
          removeSignUpTokenAfterSuccessfulSignup();
          setShowModal(true);
          setUsername(res?.userName);
        }
      },
      onError: (error: AxiosError<{ message: string }>) => {
        handleError({ error, errorFn });
      },
    },
  );

  const handleClick = async (data: TUpdateUser) => {
    updateUserInfo.mutate(data);
  };
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.chooseCategoryContainer}>
        <span>
          <div className={styles.headerText}>Please pick the category you belong to</div>
          <div className='mt-5'></div>

          <div className={styles.categoriesContainer}>
            <CategoryCard
              image={<BusinessImg src={unregisteredImg} />}
              category={'UNREGISTERED'}
              checked={selectedOption === 'UNREGISTERED' ? true : false}
              description={'I do business in my name and I am yet to register with the CAC'}
              header={'Unregistered Business'}
              setCategory={setSelectedOption}
            />

            <CategoryCard
              image={<BusinessImg src={registeredLogo} />}
              category={'REGISTERED'}
              checked={selectedOption === 'REGISTERED' ? true : false}
              description={'My business is registered with the Corporate Affairs Commission (CAC)'}
              header={'Registered Business'}
              setCategory={setSelectedOption}
            />
          </div>

          <div className='mt-5'></div>

          <div className='flex justify-center'>
            <button
              className={[styles.proceedBtn, 'w-64 sm:w-80', colorStyle].join(' ')}
              onClick={() => {
                !isDisabled &&
                  !updateUserInfo?.isLoading &&
                  handleClick({
                    ageOfBusiness: yearsInBusiness,
                    businessRegistered: selectedOption === 'REGISTERED' ? true : false,
                  });
                registerNetcoreActivity(
                  {
                    emailAddress: email && email,
                    firstName: firstName && firstName,
                    lastName: lastName && lastName,
                    mobileNumber: phoneNumber && phoneNumber,
                  },
                  'TBH_SIGN_UP_USER_CATEGORY_TYPE',
                );

                ReactGA.event({
                  category: 'Button',
                  action: 'TBH_SIGN_UP_USER_CATEGORY_TYPE',
                  label: 'TBH_SIGN_UP_USER_CATEGORY_TYPE',
                  // value: 1
                });
              }}
            >
              {updateUserInfo.isLoading ? 'Please wait...' : 'Proceed'}
            </button>
          </div>

          <WelcomeModal setShowModal={setShowModal} showModal={showModal} username={username} />
        </span>
      </div>

      <UnVerifiedPhoneModal
        setShowModal={setShowUnverifiedPhoneModal}
        showModal={showUnverifiedPhoneModal}
        showPhoneOtpModal={() => setTokenSent(true)}
        closeEmailOtpModal={() => {
          return;
        }}
      />

      <OtpModal
        pageComingFrom={'Login'}
        showModal={tokenSent}
        setShowModal={setTokenSent}
        setShowSuccessModal={() => {
          return;
        }}
      />
    </div>
  );
}
